import type { ServicesPwsChatSessionView } from '../ServicesPwsChat/types';

function asRecord(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : null;
}

function isConstructionController(value: Record<string, unknown>): boolean {
  return value.status === 'construction_sow_chat' || asRecord(value.workflow)?.workflow_type === 'one_time_construction';
}

/** Accept only the server-issued Services PWS controller envelope. */
export function extractServicesPwsRouterResponse(value: unknown): ServicesPwsChatSessionView | null {
  const root = asRecord(value);
  if (!root || isConstructionController(root)) return null;
  if (typeof root.session_id === 'string' && typeof root.home_chat_session_id === 'string' && typeof root.cursor === 'string' && asRecord(root.intake)) {
    return root as unknown as ServicesPwsChatSessionView;
  }
  const candidate = root.status === 'services_pws_chat' || root.status === 'handoff_ready'
    ? asRecord(root.services_pws_chat) : null;
  if (!candidate || typeof candidate.session_id !== 'string' || isConstructionController(candidate)) return null;
  const homeChatSessionId = typeof root.home_chat_session_id === 'string' ? root.home_chat_session_id
    : typeof candidate.home_chat_session_id === 'string' ? candidate.home_chat_session_id : undefined;
  return { ...(candidate as unknown as ServicesPwsChatSessionView), ...(homeChatSessionId ? { home_chat_session_id: homeChatSessionId } : {}) };
}
